import { Link } from '@mui/icons-material'
import { type ReactEventHandler, useState } from 'react'
import { StatusButton } from '@/components/StatusButton'
import { useClipboard } from '@/features/clipboard/useClipboard'
import { useSearch } from '@/features/search/hooks/useSearch'
import { useAppSelector } from '@/redux/hooks'

export const CopyLinkButton = () => {
  const { copyToClipboard } = useClipboard()
  const { selectors } = useSearch()
  const criteria = useAppSelector(selectors.selectActiveSearchCriteriaString)
  const [isSuccess, setSuccess] = useState(0)

  const handleCopy: ReactEventHandler = (_event) => {
    if (!criteria) return
    copyToClipboard(`${window.location.origin}/n/search?Criteria=${criteria}`)
    setSuccess((prev) => prev + 1)
  }

  return (
    <StatusButton
      disabled={!criteria}
      isSuccess={Boolean(isSuccess)}
      startIcon={<Link />}
      onClick={handleCopy}
    >
      Copy Search URL
    </StatusButton>
  )
}
